import React, { Component } from 'react';

class Users extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>User Information</h2>
                        <p>
                            Towva ensures your damaged or broken-down vehicle gets to where you want it to go with the least amount of hassle! 
                        </p>
                    </div>
                </div>
                <div className="container bottom-pad">
                    <div className="info-grid">
                        <div className="" data-aos="fade-left">
                            <div className="user-info-img">
                                <img src={require("./../images/phone-app.png")} width="100%" alt=""/>
                            </div>
                        </div>
                        <div className="info-grid-text" data-aos="fade-right">
                            <div>
                                <br/>
                                <h4>Tap the app, get a ride</h4>
                                <p>
                                    Towva is the most efficient way to ensure that your vehicle gets where it needs to. All you need to do is download the app, register and tap the app to get roadside assistance anytime, anywhere!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row cent">
                        <div className="col-md-6" data-aos="fade-up">
                            <div className="why-img">
                                <img src={require("./../images/how-to-pay.png")} width="100%" alt=""/>
                            </div>
                            <h4>Choose how you pay</h4>
                            <p>
                                Unlike conventional services, Towva gives you the liberty to pay for the towing service once you’re at your destination. You can also choose the mode of payment most convenient for you- either you pay with cash or you have it deducted from your debit card.
                            </p>
                        </div>
                        <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="why-img">
                                <img src={require("./../images/crown-icon.png")} width="100%" alt=""/>
                            </div>
                            <h4>Customer is King</h4>
                            <p>
                                Towva affords users the opportunity to provide anonymous feedback about the ride, as well as the quality of the service provided. This allows us to improve our services and make future experiences better. You rate, we listen!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="blue-sect">
                    <div className="container-personal">
                        <div className="about-user">
                            <h2>User Safety</h2>
                            <p>
                                Towva believes in ensuring the total safety of app users. This is why we go the extra mile to make sure both rider and service provider are safe.
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-md-6" data-aos="zoom-in" data-aos-delay="900">
                                <div className="about-user-img">
                                    <img src={require("./../images/big-shield-icon.png")} width="100%" alt=""/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="about-user-info">
                                    <h4 data-aos="fade-up">How do we ensure safety?</h4>
                                    <p data-aos="fade-up" data-aos-delay="100">
                                        <span>Information database:</span> Towva has an extensive database of all its riders and service providers that ensures that in case of any incident, the parties in question can be easily traced. 
                                    </p>
                                    <p data-aos="fade-up" data-aos-delay="200">
                                        <span>Ride history:</span> Every ride taken is recorded, so that proper reference can be made, just in case.
                                        24/7 support:  In case of suspicious activity on the part of the service provider, customer support can be contacted for assistance.
                                    </p>
                                    <p data-aos="fade-up" data-aos-delay="300">
                                        <span>Feedback:</span> To ensure that the services provided by the towing service providers are up to par, riders have the option of leaving feedback and ratings on rides. This way, unsavory service providers can be disassociated from the app
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
}
 
export default Users;